<template>
  <div>
    <div v-if="!pageLoading">
      <back-nav to="VehicleDetails" />
      <top-card current="CoverSummary" :cover="coverType.covertypeId" :amount="coverType.riskPremDto.totalPremium">Please confirm that the information below is accurate before you proceed to pay</top-card>
      <v-card flat class="tw-mt-5 md:tw-mt-16">
        <div class="tw-px-4 md:tw-px-8">
          <card-title>Cover Details</card-title>
        </div>
        <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
          <div class="tw-w-full">
            <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Personal Details</h3>
            <hr class="tw-mt-3 tw-mb-5">
          </div>
          <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-px-2 md:tw-px-8">
            <v-row>
              <v-col sm="6"><strong>Full Name</strong></v-col>
              <v-col sm="6">{{ user.fullName }}</v-col>
            </v-row>
            <v-row>
              <v-col sm="6"><strong>ID Number</strong></v-col>
              <v-col sm="6">{{ user.idNumber }}</v-col>
            </v-row>
            <v-row>
              <v-col sm="6"><strong>Email</strong></v-col>
              <v-col sm="6">{{ user.email }}</v-col>
            </v-row>
            <v-row>
              <v-col sm="6"><strong>Phone Number</strong></v-col>
              <v-col sm="6">{{ user.mobileNumber }}</v-col>
            </v-row>
            <v-row>
              <v-col sm="6"><strong>KRA PIN</strong></v-col>
              <v-col sm="6">{{ user.kraPinNumber }}</v-col>
            </v-row>
            <v-row>
              <v-col sm="6"><strong>Address</strong></v-col>
              <v-col sm="6">{{ user.poBoxNo }}, {{ user.postalCode }}</v-col>
            </v-row>
          </div>

          <div class="tw-w-full">
            <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Vehicle Details</h3>
            <hr class="tw-mt-3 tw-mb-5">
          </div>
          <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-px-2 md:tw-px-8">
            <v-row>
              <v-col sm="6"><strong>Vehicle Make</strong></v-col>
              <v-col sm="6">{{ car.make }}</v-col>
            </v-row>
            <v-row>
              <v-col sm="6"><strong>Registration Number</strong></v-col>
              <v-col sm="6">{{ car.registrationNumber.toUpperCase() }}</v-col>
            </v-row>
            <v-row>
              <v-col sm="6"><strong>Vehicle Model</strong></v-col>
              <v-col sm="6">{{ car.model }}</v-col>
            </v-row>
            <v-row>
              <v-col sm="6"><strong>Value of Vehicle (Kshs.)</strong></v-col>
              <v-col sm="6">{{ car.valueOfCar | formatNum }}</v-col>
            </v-row>
            <v-row>
              <v-col sm="6"><strong>Year of Manufacture</strong></v-col>
              <v-col sm="6">{{ car.yearOfManufacture }}</v-col>
            </v-row>
            <v-row>
              <v-col sm="6"><strong>Vehicle Engine No.</strong></v-col>
              <v-col sm="6">{{ car.engineNumber }}</v-col>
            </v-row>
          </div>

          <div v-if="coverType.covertypeId === 101 && 'additionalBenefits' in this.coverType && beneficiaries.length > 0">
            <div class="tw-w-full">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Travel Embedded Beneficiaries ({{ beneficiaries.length }})</h3>
              <hr class="tw-mt-3 tw-mb-5">
            </div>
            <div class="tw-w-full tw-flex tw-px-2 md:tw-px-8">
              <div v-for="(beneficiary, $index) in beneficiaries" :key="$index" class="tw-flex tw-flex-wrap tw-w-full md:tw-w-1/3 tw-px-0 md:tw-px-6" >
                <v-card class="tw-w-full tw-p-2" outlined>
                  <v-row>
                    <v-col sm="6"><strong>Name</strong></v-col>
                    <v-col sm="6">{{ beneficiary.fullName }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6"><strong>Passport/ID Number</strong></v-col>
                    <v-col sm="6">{{ beneficiary.passportNumber }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6"><strong>Relationship</strong></v-col>
                    <v-col sm="6">{{ beneficiary.relationship }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="6"><strong>Date Of Birth</strong></v-col>
                    <v-col sm="6">{{ beneficiary.dateOfBirth | formatDate }}</v-col>
                  </v-row>
                </v-card>
              </div>
            </div>
          </div>

          <div class="tw-w-full">
            <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Benefits</h3>
            <hr class="tw-mt-3 tw-mb-5">
          </div>
          <div v-if="coverType.covertypeId === 101" class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mt-4 md:tw-mt-10">
            <div>
              <div class="tw-px-0 md:tw-px-4">
                <v-toolbar color="primary1" flat dense>
                  <v-toolbar-title class="c-white-text">Free Benefits</v-toolbar-title>
                </v-toolbar>
              </div>
              <div class="tw-w-full tw-mt-3 md:tw-mt-5 tw-px-2 md:tw-px-6 tw-border-r-0 md:tw-border-r-2 tw-border-gray-400">
                <benefits />
              </div>
            </div>

            <div>
              <div class="tw-px-0 md:tw-px-4">
                <v-toolbar color="primary" flat dense>
                  <v-toolbar-title class="c-white-text">Additional Benefits</v-toolbar-title>
                </v-toolbar>
              </div>
              <div class="tw-w-full tw-mt-3 md:tw-mt-5 tw-px-2 md:tw-px-6">
                <div class="tw-w-full tw-flex tw-flex-wrap tw-mt-5">
                  <div v-if="benefits.length > 0" class="tw-w-full tw-flex tw-grid tw-grid-cols-1
                 md:tw-grid-cols-2">
                    <v-checkbox v-for="(benefit, $index) in benefits" :key="$index" v-model="checked" disabled>
                      <template #label>
                        <ul class="list-none">
                          <li>{{ benefit.benefit }}</li>
                          <li class="tw-mt-1"><span class="c-blue-text">Sum of Kes. {{ benefit.premium }}</span></li>
                        </ul>
                      </template>
                    </v-checkbox>
                  </div>
                  <div v-else>
                    <p>No Additional Benefits Selected</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="tw-w-full tw-flex tw-justify-center tw-mt-4">
            <div class="tw-w-full md:tw-w-6/12">
              <div class="tw-px-0 md:tw-px-4">
                <v-toolbar color="primary1" flat dense>
                  <v-toolbar-title class="c-white-text">Benefits</v-toolbar-title>
                </v-toolbar>
              </div>
              <div class="tw-w-full tw-mt-3 md:tw-mt-5 tw-px-2 md:tw-px-6">
                <third-party-benefits />
              </div>
            </div>
          </div>

          <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 md:tw-mt-8 tw-pb-8">
            <v-btn block large
                   color="secondary"
                   class="my-3 "
                   :loading="loading"
                   @click="proceed">
              Continue
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="80"
          color="primary1"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import TopCard from '@/components/buy/TopCard';
import CardTitle from '@/components/shared/CardTitle';
import Benefits from '@/components/shared/Benefits';
import BackNav from '@/components/buy/BackNav';
import { mapGetters } from 'vuex';
import helpers from '@/utils/helpers';
import ThirdPartyBenefits from '@/components/shared/ThirdPartyBenefits';
import moment from 'moment';
import { FB_BUY_COVER_SUMMARY } from '@/utils/const';

export default {
  name: 'CoverSummary',
  components: {
    ThirdPartyBenefits,
    BackNav,
    Benefits,
    CardTitle,
    TopCard,
  },
  data() {
    return {
      loading: false,
      pageLoading: true,
      checked: true,
      beneficiaries: [],
    };
  },
  computed: {
    ...mapGetters('rfq', ['getQoute']),
    coverType() {
      return this.getQoute !== {} ? this.getQoute.covertypes.find((e) => e.riskId === parseInt(this.$route.query.b, 10)) || this.getQoute.covertypes.find((e) => e.selected === 'Y') : {};
    },
    user() {
      return this.getQoute.client;
    },
    car() {
      return this.coverType.car;
    },
    benefits() {
      return this.coverType.additionalBenefits || [];
    },
  },
  mounted() {
    const quote = this.$route.query.q;
    this.$store.dispatch('rfq/getQuotation', quote).then(() => {
      this.pageLoading = false;
    });
    if (this.coverType.covertypeId === 101 && 'additionalBenefits' in this.coverType && 'beneficiaries' in this.coverType) {
      this.coverType.beneficiaries.forEach((b) => {
        this.beneficiaries.push({
          fullName: b.fullName,
          passportNumber: b.passportNumber,
          dateOfBirth: b.dateOfBirth,
          relationship: b.relationship,
        });
      });
    }
  },
  methods: {
    proceed() {
      this.$analytics.logEvent(FB_BUY_COVER_SUMMARY);
      this.$emit('to-branch-selection');
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD').format('Do MMM YYYY');
    },
  },
};
</script>

<style scoped>
.list-none{
  list-style: none!important;
}
</style>
